import React, { Component } from 'react';
import moment from 'moment';
import has from 'lodash/has';
import isEmpty from 'lodash/isEmpty';
import size from 'lodash/size';
import ceil from 'lodash/ceil';
import get from 'lodash/get';
import ReactTooltip from 'react-tooltip';
import If from '../../../components/Shared/If';
import {whiteLabelStyling} from '../../../utils/constants';
import { deepClone } from '../../../utils/copyObject';
import { calculateIndexRange } from '../../../utils/dashboardUtils';
import Paginations from '../../../components/Pagination/Pagination';
import { sortArray, sortDatesArray, sortNumbersArray } from '../../../components/Shared/ReusablesUtils';
import '../Analytics.css';
import NoDataFound from '../../../assets/no-kpidata-range.png';

class ChartsGrid extends Component {

    constructor(props) {
        super(props);
        this.state = {
            adminSortOrder: 'asc',
            gridPagination: {
                currentPage: 1,
                recordCount: 10
            },
            chartAnalytics: this.props.chartsAnalytics && size(this.props.chartsAnalytics.length) > 0 ? deepClone(this.props.chartsAnalytics) : [],
            searchKey: this.props.searchObject && !isEmpty(this.props.searchObject.chartname) ? get(this.props.searchObject, 'chartname', '') : ''
        }
    }

    componentWillReceiveProps(nextProps) {
        let { searchKey } = this.state;
        if (nextProps.searchObject.chartname !== searchKey) {
            this.setState({
                gridPagination: {
                    ...this.state.gridPagination,
                    currentPage: 1,
                    recordCount: 10
                }
            });
        }
        this.setState({
            chartAnalytics: nextProps.chartsAnalytics.map((eachChart) => {
                return { ...eachChart, createdBy: this.getCreatedByName(eachChart.createdBy) }
            })
        });
    }

    getCreatedByName = (item) => {
        if (!isEmpty(item.firstName) && !isEmpty(item.lastName) && item["firstName"] !== undefined && item["lastName"] !== undefined) {
            return `${item.firstName} ${item.lastName}`
        }
        return 'NA';
    }

    renderList = (list) => {
        if (list && list.length > 0) {
            return list.map((item, index) => (
                <tr key={index}>
                    <td >
                        <span className="tooltip-text" data-tip={item.name}>{item.name}</span>
                        <ReactTooltip />
                    </td>
                    <td>{moment(item.createdDate).format('MM/DD/YYYY')}</td>
                    <td>{item.createdBy}</td>
                    <td>{item.category}</td>
                </tr>
            ));
        }
        return <tr><td>No record found</td></tr>;
    };

    sortChartName = (key) => {
        let adminSortOrder;
        if (this.state.adminSortOrder === 'asc') {
            adminSortOrder = 'desc';
        } else {
            adminSortOrder = 'asc';
        }

        let sortedKeysResult = this.props.chartsAnalytics.map((eachChart) => {
            return { ...eachChart, createdBy: this.getCreatedByName(eachChart.createdBy) }
        });

        this.setState({ adminSortOrder }, () => {
            let updatedList = sortArray(sortedKeysResult, key, this.state.adminSortOrder);
            this.setState({
                chartAnalytics: updatedList
            });
        });
    }

    sortDates = (key) => {
        let adminSortOrder;
        if (this.state.adminSortOrder === 'asc') {
            adminSortOrder = 'desc';
        } else {
            adminSortOrder = 'asc';
        }

        let sortedKeysResult = this.props.chartsAnalytics.map((eachChart) => {
            return { ...eachChart, createdBy: this.getCreatedByName(eachChart.createdBy) }
        });


        this.setState({ adminSortOrder }, () => {
            let updatedList = sortDatesArray(sortedKeysResult, key, this.state.adminSortOrder);
            this.setState({
                chartAnalytics: updatedList
            });
        });
    }

    handlePageNavigation = (nextOrPrevious) => {
        if (nextOrPrevious === 'previous' || nextOrPrevious === 'next') {
            this.setState(
                {
                    gridPagination: {
                        ...this.state.gridPagination,
                        currentPage: nextOrPrevious === 'previous' ? parseInt(this.state.gridPagination.currentPage - 1) : parseInt(this.state.gridPagination.currentPage + 1)
                    }
                }
            );
        } else {
            this.setState(
                {
                    gridPagination: {
                        ...this.state.gridPagination,
                        currentPage: parseInt(nextOrPrevious)
                    }
                }
            );
        }

    }

    handleRecordCountChange = (event) => {
        let { value } = event.target;
        let { gridPagination: { recordCount } } = this.state;
        this.setState({ gridPagination: { ...this.state.gridPagination, recordCount: parseInt(value), totalPage: ceil(size(this.state.userAnalytics) / recordCount) } });
    }

    generatePageNumbers = (userAnalytics) => {
        let { currentPage, recordCount } = this.state.gridPagination;
        let pageNumbers = [];

        if (recordCount > size(userAnalytics)) {
            pageNumbers = [];
        } else {
            for (let i = 1; i <= ceil(size(userAnalytics) / recordCount); i++) {
                pageNumbers.push(<li key={i} className="page-item"><span className={currentPage === i ? 'page-link currentpage-active' : 'page-link'} onClick={() => this.handlePageNavigation(i)}>{i}</span></li>)
            }
        }
        // Slice only 1 to 10 Page
        let pageNumbersInitial = pageNumbers.slice(0, 10);
        return pageNumbersInitial;
    }

    render() {

        let { chartAnalytics } = this.state;
        let { gridPagination: { currentPage, recordCount } } = this.state;
        let test = calculateIndexRange(currentPage, recordCount);
        const slicedRecords = chartAnalytics.slice(test.begin, test.end);
        let totalPageNumber = ceil(size(chartAnalytics) / recordCount);
        let nodataFound = null;
        if(chartAnalytics && chartAnalytics.length === 0) {
          nodataFound = (<div className="text-center no-data-available-desc">
            <p style={{marginBottom: '0px'}}>Looks like there's no data available for the parameters you selected.</p>
            <p> Try adjusting your filters, dates.</p>
            <img src={NoDataFound} className="no-kpi-date-range"/>
          </div>)
        }

        return (
            <div>
                {chartAnalytics.length > 0 && (
                <div>
                <div className="row p-0 m-0 mt-3 mb-2 table-responsive-sm table-ellipsis">
                    <table className="toolkit-list table text-primary-color tool-list-font" style={{ borderTop: '0px' }}>
                        <thead>
                            <tr className="col-sm-4 mb-3">
                                <th scope="col" className='bottom-border-color' ><span className="table-sort-title">Chart Name</span><span onClick={() => this.sortChartName('name')} className="table-sort-icon fa fa-sort"></span></th>
                                <th scope="col" className='bottom-border-color' ><span className="table-sort-title">Date Created</span><span onClick={() => this.sortDates('createdDate')} className="table-sort-icon fa fa-sort"></span></th>
                                <th scope="col" className='bottom-border-color' ><span className="table-sort-title">Created by</span><span onClick={() => this.sortChartName('createdBy')} className="table-sort-icon fa fa-sort"></span></th>
                                <th scope="col" className='bottom-border-color' ><span className="table-sort-title">Chart Category</span><span onClick={() => this.sortChartName('category')} className="table-sort-icon fa fa-sort"></span></th>
                             
                            </tr>
                        </thead>
                        <tbody>{this.renderList(slicedRecords)}</tbody>
                    </table>
                </div>
                <If condition={size(chartAnalytics) > 0}>
                    <Paginations
                        currentPage={currentPage}
                        totalPageNumber={totalPageNumber}
                        handlePageNavigation={this.handlePageNavigation}
                        Analytics={chartAnalytics}
                        generatePageNumbers={this.generatePageNumbers}
                        handleRecordCountChange={this.handleRecordCountChange}
                        recordCount={recordCount}
                        totalRecords={size(chartAnalytics)}
                    />
                </If>
                </div>
                )}
                {nodataFound}
            </div>
        )
    }
}

export default ChartsGrid;